// extracted by mini-css-extract-plugin
export default {"keywordSelector":"QcXoEW","selected":"md30l4"};